import * as React from 'react';
import { useUser } from '@clerk/nextjs';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { AccountCycle, AccountUserCard, AccountMostViewedWorkouts, AccountRecentWorkouts, AccountSubscription } from '@/components/account';
import { getUserMetadata } from '@/utils/auth/getUserMetadata';
import { trpc } from '@/utils/trpc';

const AccountPage: NextPage = () => {
  const {
    user
  } = useUser();
  const {
    userId,
    username
  } = getUserMetadata(user);
  const {
    data: dbUser
  } = trpc.users.byId.useQuery({
    id: userId || ''
  }, {
    enabled: !!userId
  });
  if (!user || !userId || !dbUser) return <></>;
  return <>
      <NextSeo title='My Account' />
      <div className='mx-auto max-w-3xl flex flex-col gap-y-5'>
        <AccountUserCard dbUser={dbUser.data} username={username} />
        <AccountCycle dbUser={dbUser.data} />
        <AccountSubscription dbUser={dbUser.data} />
        <AccountRecentWorkouts dbUser={dbUser.data} />
        <AccountMostViewedWorkouts dbUser={dbUser.data} />
      </div>
    </>;
};

export default AccountPage;